<template>
  <section class="cta-banner">
    <div class="container cta-banner__inner">
      <h2 class="cta-banner__title">{{ t('ctaBanner.title') }}</h2>
      <p class="cta-banner__desc">{{ t('ctaBanner.desc') }}</p>
      <NuxtLink
        :to="localePath('/register')"
        class="btn btn-primary btn-lg cta-banner__btn">
        {{ t('ctaBanner.cta') }}
      </NuxtLink>
    </div>
  </section>
</template>

<script setup>
const { t } = useI18n()
const localePath = useLocalePath()
</script>

<style scoped>
.cta-banner {
  background: linear-gradient(90deg, #113042 0%, #271346 100%);
  padding-block: var(--space-16);
}

.cta-banner__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--space-5);
}

.cta-banner__title {
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: var(--tracking-tight);
}

.cta-banner__desc {
  font-size: var(--text-base);
  color: var(--text-secondary);
  line-height: var(--leading-relaxed);
  max-width: 480px;
}
</style>
